import { QWIKBOX_STORAGE_BASE_URL } from 'src/app/constants/storage.constants';
import { Injectable, isDevMode } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { FlashMessagesService } from 'angular2-flash-messages';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from './local-storage.service';
import { environment } from 'src/environments/environment';


@Injectable()
export class ApiHelperService {

  constructor(
    // private flashMessages: FlashMessagesService,
    private toastr: ToastrService,
    private localStorageService: LocalStorageService
  ) { }

  apiHeader(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    return headers;
  }

  apiHeaderWithToken(token: string = null): HttpHeaders {
    let headers = this.apiHeader();
    if (!token) token = this.localStorageService.getToken();
    if (token) headers = headers.append('Authorization', token);
    return headers;
  }

  apiUrl(): string {
    return environment.apiBaseUrl;
  }

  qwikcutEncoderUrl(): string {
    return 'https://upload.qwikcut.com/upload';
  }

  qwikcutEncoderUrlMerge(): string {
    return 'https://upload.qwikcut.com/combine';
  }

  qwikcutEncoderUrlReset(): string {
    return 'https://upload.qwikcut.com/reset';
    // return 'http://localhost:4567/reset';
  }

  qwikcutEncoderUrlPlaylist(): string {
    return 'https://upload.qwikcut.com/playlist';
  }

  qwikcutProfilePic(url?: string): string {
    return `${QWIKBOX_STORAGE_BASE_URL}/profile_pics`;
  }

  billboardContent(postContent: string): string {
    let folderBillboard = 'billboards';
    if (isDevMode()) {
      folderBillboard = 'dev_billboards';
    }

    return `${QWIKBOX_STORAGE_BASE_URL}/${folderBillboard}/${postContent}`;
  }

  showSuccessResponse(message: string, timeOut: number = 5000): void {
    this.toastr.success(message, 'Success!', { timeOut });
  }

  showWarnResponse(message: string, timeOut: number = 5000): void {
    this.toastr.warning(message, 'Warning!', { timeOut });
  }

  showInfoResponse(message: string, timeOut: number = 5000): void {
    this.toastr.info(message, 'Info', { timeOut });
  }

  showErrorResponse(message: string): void {
    const stack = (new Error(message)).stack;
    console.error(message);
    console.warn(stack);
    this.toastr.error(message, 'Error!');
  }
}
